import Layout from '@/layout'

const settingsRouter = {
  path: '/settings',
  component: Layout,
  redirect: '/settings/index',
  alwaysShow: true,
  meta: {
    title: '设置',
    icon: 'drag',
    roles: ['admin', 'editor']
  },
  children: [
    {
      path: 'passwordset',
      component: () => import('../../views/setting/passwordset.vue'),
      name: 'passwordset',
      hidden: false,
      meta: {
        title: '密码设置',
        roles: ['admin'],

      }
    }
  ]
}
export default settingsRouter
